import { HistoryStackEntry } from "../types/HistoryStackEntry";
import { NavigationEventType } from "../types/NavigationEventType";
import { PageEnterDetail } from "../types/PageEnterDetail";

interface ProcessHistoryApiBasedRoutingArgs {
  emitEvent: (type: NavigationEventType, detail?: PageEnterDetail) => void;
  fscriptId: string;
  HistoryIndexKey: string;
  historyStack: HistoryStackEntry[];
  HistoryStackKey: string;
  lastKnownIndex: number;
  fscriptSessionId: string;
}

export const processHistoryApiBasedRouting = ({
  emitEvent,
  fscriptId: _fscriptId,
  HistoryIndexKey,
  historyStack,
  HistoryStackKey,
  lastKnownIndex,
  fscriptSessionId,
}: ProcessHistoryApiBasedRoutingArgs) => {
  const fscriptId = _fscriptId || history.state.fscriptId;

  // Find the page in history stack by fscriptId
  let targetIndex = historyStack.findIndex(
    (entry) => entry.fscriptId === fscriptId
  );

  console.log("processHistoryApiBasedRouting", { fscriptId, targetIndex });

  if (targetIndex === -1) {
    // If not found, check if the current URL is in the history stack
    targetIndex = historyStack.findIndex(
      (entry) => entry.url === location.href
    );
  }

  let newCurrentIndex = lastKnownIndex;

  if (targetIndex === -1) {
    // Page not found in history stack
    newCurrentIndex = lastKnownIndex + 1;
    historyStack = historyStack.slice(0, newCurrentIndex);

    setTimeout(() => {
      historyStack.push({
        url: location.href,
        fscriptId,
      });

      localStorage.setItem(
        HistoryStackKey + fscriptSessionId,
        JSON.stringify(historyStack)
      );
      localStorage.setItem(
        HistoryIndexKey + fscriptSessionId,
        newCurrentIndex.toString()
      );

      emitEvent("page_load", "back_forward_to_unknown_history");
    }, 0);

    return;
  }

  let eventTypeToEmit: NavigationEventType;
  let eventDetailToEmit: PageEnterDetail | undefined;

  // Determine direction based on index comparison
  if (targetIndex < lastKnownIndex) {
    eventTypeToEmit = "browser_back";
  } else if (targetIndex > lastKnownIndex) {
    eventTypeToEmit = "browser_forward";
  } else {
    eventTypeToEmit = "page_load";
    eventDetailToEmit = "history_jump_to_same_effective_index";
  }

  newCurrentIndex = targetIndex;

  localStorage.setItem(
    HistoryStackKey + fscriptSessionId,
    JSON.stringify(historyStack)
  );
  localStorage.setItem(
    HistoryIndexKey + fscriptSessionId,
    newCurrentIndex.toString()
  );

  const timer = setInterval(() => {
    if (!history.state.fscriptId && targetIndex !== -1) {
      const prefHistoryState = { ...history.state };
      const nextFScriptId = historyStack[targetIndex].fscriptId;
      const finalState = prefHistoryState
        ? {
            ...prefHistoryState,
            fscriptId: nextFScriptId,
            __PRIVATE_NEXTJS_INTERNALS_TREE: [
              ...prefHistoryState.__PRIVATE_NEXTJS_INTERNALS_TREE,
              nextFScriptId,
            ],
          }
        : { fscriptId: nextFScriptId };

      window.history.replaceState(finalState, "");
      clearInterval(timer);
    }
  }, 1);

  setTimeout(() => {
    clearInterval(timer);
  }, 1000);

  emitEvent(eventTypeToEmit, eventDetailToEmit);

  return timer;
};
